// eslint-disable-next-line import-x/default
import pdfMake from "pdfmake/build/pdfmake";
import vfs from "pdfmake/build/vfs_fonts";
import { TCreatedPdf, TDocumentDefinitions } from "pdfmake/interfaces";

pdfMake.addVirtualFileSystem(vfs);

export type PdfDocument = TCreatedPdf;

export const createConfiguredPdf = (docDefinition: TDocumentDefinitions): PdfDocument =>
	pdfMake.createPdf(docDefinition);
